/**
 * Helpers and types
 */
import {pure} from '@react/store'
import string from '@helpers/string'
import {http} from '@helpers/common'
import {UserInterface, DefaultComponentProps} from '@interface/common'


/**
 * Assets
 */
import './controls.scss'

/**
 * Images
 */
import Close from '@assets/images/close.png'


const statuses = [
  {value: 'active', name: 'Activate'},
  {value: 'archived', name: 'Archive'},
  {value: 'suspended', name: 'Suspend'},
]
/**
 * Alert
 */
export default pure(({user, store, modal, data}: {data:any} & DefaultComponentProps) => {
  const state = store.useLocalState({
    error: null,
    status: '',
    admins: []
  }, data)

  const creator = data.admins.find((v:any) => v.uid === data.creator)


  function onChange(e:any) {
    http.put('/organizations/groups', {
      data: {
        uid: user.uid,
        sid: data.sid,
        gid: data.gid,
        data: {
          status: e.target.value
        }
      }
    })
    .then(({status}) => {
      if(status === 200) {
        state.set({status: e.target.value})
      }
    })
    .catch(console.error)
  }


  function makeOwner(item:UserInterface) {
    http.put('/organizations/groups', {
      data: {
        uid: user.uid,
        sid: data.sid,
        gid: data.gid,
        data: {
          creator: item.uid
        }
      }
    })
    .then(({status}) => {
      if(status === 200) {
        state.set({creator: item.uid})
      }
    })
    .catch(console.error)
  }


  function revokeAdmin(item:UserInterface) {
    http.put('/organizations/groups/members', {
      data: {
        uid: item.uid,
        sid: data.sid,
        gid: data.gid,
        data: {
          role: 'member'
        }
      }
    })
    .then(({status}) => {
      if(status === 200) {
        state.set({
          admins: state.admins.filter((v:any) => v.uid !== item.uid)
        })
      }
    })
    .catch(console.error)
  }


  return (
    <div
      id="controls"
      onClick={(e) => {
        e.stopPropagation()
      }}>
      <div className="head">
        <h3>Manage Group</h3>
        <span
          className="close"
          onClick={modal.close}>
          <img alt="Close" src={Close}/>
        </span>
      </div>
      <div>
        <p>Manage group settings, controls and other related information of the group.</p>
      </div>

      {state.error && (
        <p className="error">{state.error}</p>
      )}

      <fieldset id="information">
        <h4>Information</h4>
        <ul className="info">
          <li>
            <strong>Name</strong>
            <p>{data.name}</p>
          </li>
          <li>
            <strong>Members</strong>
            <p>{data.members}</p>
          </li>
          <li>
            <strong>Admins</strong>
            <p>{data.admins.length}</p>
          </li>
          <li>
            <strong>Type</strong>
            <p>{data.type}</p>
          </li>
          <li>
            <strong>Status</strong>
            <p>{string.toUCFirst(data.status)}</p>
          </li>
          <li>
            <strong>Creator</strong>
            <p>{creator.firstname} {creator.lastname}</p>
          </li>
        </ul>
      </fieldset>


      <fieldset id="provision">
        <h4>Provision</h4>
        <div className="radio-group">
          {statuses.map((item:any, index:number) => (
            <label key={index} className="radio-label">
              <input type="radio" name="status" onChange={onChange} value={item.value} checked={state.status === item.value}/>
              <span className="radio"></span>
              {item.name}
            </label>
          ))}
        </div>
      </fieldset>

      {/* <fieldset id="provision">
        <h4>Provision</h4>
        <div className="switch">
          <label className="toggle">
            <input type="checkbox" />
            <span className="slider"></span>
          </label>
          <span className="text-label">Suspend Space</span>
        </div>
        <div className="switch">
          <label className="toggle">
            <input type="checkbox" />
            <span className="slider"></span>
          </label>
          <span className="text-label">Archive Space</span>
        </div>
      </fieldset> */}

      <fieldset id="administrators">
        <h4>Administrators</h4>
        <ul className="clear">
          <li>
            <strong>Name</strong>
            <strong>Status</strong>
            <strong>Action</strong>
          </li>
          {state.admins.map(
            (item:UserInterface, index:number) => {
              return (
                <li key={index}>
                  <span className="name">
                    {item.firstname} {item.lastname}
                    {state.creator === item.uid && (<em>(Owner)</em>)}
                  </span>
                  <span className="status">{string.toUCFirst(item.status)}</span>
                  <span className="action">

                    <button className="revoke-admin" disabled={state.admins.length === 1} onClick={() => revokeAdmin(item)}>Revoke Admin</button>
                    {state.creator !== item.uid && (
                      <button className="make-owner" onClick={() => makeOwner(item)}>Make Owner</button>
                    )}
                  </span>
                </li>
              )
            }
          )}
        </ul>
      </fieldset>
    </div>
  )
})